import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export var PrivateRoute = function (_a) {
    var user = _a.user, _b = _a.unauthorizedComponent, unauthorizedComponent = _b === void 0 ? 'Unauthorized' : _b, children = _a.children;
    return _jsx(_Fragment, { children: user ? children : unauthorizedComponent });
};
export default PrivateRoute;
